// Reporting's Table view (owner, 2026-11-04 — D-472: "Table would be a basic
// table view of the same information presented in the visual"). The same rows
// the Visual draws as bars, as two columns: the chart's label heading and its
// value heading, each value printed as the bar prints it. Not a filter
// control: only the Visual's bars toggle filters.
import { Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow, makeStyles } from '@fluentui/react-components'
import type { BarRowData } from './DashboardCharts'

const useStyles = makeStyles({
  table: { tableLayout: 'fixed', width: '100%' },
  label: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  valueHead: { width: '180px', textAlign: 'right' },
  value: { textAlign: 'right', whiteSpace: 'nowrap' },
})

export function ReportTable({
  rows,
  labelHeader,
  valueHeader,
  ariaLabel,
}: {
  rows: readonly BarRowData[]
  labelHeader: string
  valueHeader: string
  ariaLabel: string
}) {
  const s = useStyles()
  return (
    <Table size="small" className={s.table} aria-label={ariaLabel}>
      <TableHeader>
        <TableRow>
          <TableHeaderCell>{labelHeader}</TableHeaderCell>
          <TableHeaderCell className={s.valueHead}>{valueHeader}</TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((row) => (
          <TableRow key={row.key}>
            <TableCell className={s.label} title={row.title ?? row.label}>
              {row.label}
            </TableCell>
            <TableCell className={s.value}>{row.display}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
